import { httpGetObservable } from './utils';

const api = {
  deviceWarehouseList: url => httpGetObservable(url),
};

export default api;
